import { CommonModule } from '@angular/common';
import { Component, Input, OnChanges, OnInit } from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';

@Component({
  selector: 'wms-message',
  standalone: true,
  templateUrl: './wms-message.component.html',
  styleUrls: ['./wms-message.component.less'],
  imports: [
    CommonModule
  ]
})
export class WmsMessageComponent implements OnChanges, OnInit {
  @Input() scopeDataset!: any;
  @Input() customClass?: any = '';
  messageClass!: string;
  messageIconClass!: string;
  messageContent!: any;
  type!: any;
  show: boolean = true;

  constructor(private _sanitizer: DomSanitizer) { }

  ngOnChanges() {
    this.setDataSet(this.scopeDataset);
  }

  /*set caption, type & show properties */
  setDataSet(dataset: any) {
    if (!Array.isArray(dataset) && typeof (dataset) === 'object' && dataset) {
      this.messageContent = dataset.caption;
      this.type = dataset.type;
      this.show = dataset.show = true;
      switch (this.type) {
        case 'success':
          this.messageClass = 'alert-success';
          this.messageIconClass = 'wi wi-done';
          break;
        case 'error':
          this.messageClass = 'alert-danger';
          this.messageIconClass = 'wi wi-cancel';
          break;
        case 'warn':  /*To support old projects with type as "warn"*/
        case 'warning':
          this.messageClass = 'alert-warning';
          this.messageIconClass = 'wi wi-bell';
          break;
        case 'info':
          this.messageClass = 'alert-info';
          this.messageIconClass = 'wi wi-info';
          break;
        case 'loading':
          this.messageClass = 'alert-info alert-loading';
          this.messageIconClass = 'fa fa-spinner fa-spin';
          break;
      }
    } else {
      this.show = false;
    }
  }

  closeMessage(evt: any) {
    if (this.scopeDataset) {
      this.scopeDataset.show = false;
    }
    this.show = false;
  }

  ngOnInit(): void {
    this.messageContent = this._sanitizer.bypassSecurityTrustHtml(this.messageContent);
  }
}
